import { v4 as uuidv4 } from 'uuid';
import { FlexLayoutCol, FlexLayoutRow } from '../../../../vtex-apps/flex-layout/FlexLayout/default';
import { RichText } from '../../../../vtex-apps/rich-text/RichText/default';
import { NewsletterForm } from '../../../../vtex-apps/store-newsletter/NewsletterForm/default';
import { NewsletterInputEmail } from '../../../../vtex-apps/store-newsletter/NewsletterInputEmail/default';
import { NewsletterInputName } from '../../../../vtex-apps/store-newsletter/NewsletterInputName/default';
import { NewsletterCheckboxConfirmation } from '../../../../vtex-apps/store-newsletter/NewsletterCheckboxConfirmation/default';
import { NewsletterSubmit } from '../../../../vtex-apps/store-newsletter/NewsletterSubmit/default';
import { VisibilityLayout } from '../../../../vtex-apps/VisibilityLayout/default';

export default function Newsletter() {
	return {
		componentName: 'VisibilityLayout',
		componentId: uuidv4(),
		componentGroup: 'Newsletter',
		props: VisibilityLayout({ mzTitle: 'MZ | Newsletter (On/Off)' }).props,
		variables,
		childrenComponents: [
			FlexLayoutRow(
				{
					blockClass: 'footer-newsletter-2__row',
					colSizing: 'equal',
					preserveLayoutOnMobile: true,
					fullWidth: true,
					mzTitle: 'MZ | Newsletter',
				},
				[
					NewsletterForm(
						{
							blockClass: 'footer__newsletter-2',
						},
						[
							FlexLayoutRow(
								{
									blockClass: 'footer-row__newsletter-2',
								},
								[
									FlexLayoutCol(
										{
											blockClass: 'footer-col__newsletter-2',
										},
										[
											RichText({
												mzTitle: 'MZ | Newsletter - Título',
												text: 'Receba descontos e novidades diretamente no seu e-mail',
												blockClass: ['footer-rich-text__newsletter-2'],
											}),
											FlexLayoutRow(
												{
													blockClass: ['footer-inner-row__newsletter-2'],
													colSizing: 'auto',
												},
												[
													NewsletterInputName({
														blockClass: 'newsletter__input-name-2',
														inputLabel: 'Informe seu nome',
													}),
													NewsletterInputEmail({
														blockClass: 'newsletter__input-email-2',
														inputLabel: 'Informe seu email',
													}),
													NewsletterSubmit({
														blockClass: 'newsletter__submit-button-2',
														submitButtonLabel: 'Cadastrar',
													}),
												],
											),
											FlexLayoutRow(
												{
													blockClass: ['footer-inner-row__newsletter-last-2'],
													colSizing: 'auto',
												},
												[
													NewsletterCheckboxConfirmation({
														blockClass: 'footer-2',
														checkboxLabel: ' ',
													}),
													RichText({
														mzTitle: 'MZ | Newsletter - políticas',
														text: 'Ao se cadastrar você irá concordar com a nossa [Política de Privacidade](/politica-de-privacidade) e poderá alterar ou cancelar a newsletter a qualquer momento que desejar. Aqui você economiza nas suas compras e não recebe spam.',
														blockClass: ['newsletter__help-message-checkbox-2'],
													}),
												],
											),

											NewsletterSubmit({
												blockClass: 'newsletter__submit-button-mobile-2',
												submitButtonLabel: 'Cadastrar',
											}),
										],
									),
								],
							),
						],
					),
				],
			),
		],
	};
}

const variables = [
	{
		type: 'color',
		list: [
			{
				from: '--brand-color-primary-pure',
				to: '--newsletter-2-background-color',
				name: 'Background Color',
			},
			{ from: '--white', to: '--newsletter-2-text-color', name: 'Text Color' },
			{ from: '--white', to: '--newsletter-2-input-border-color', name: 'Input Border Color' },
			{ from: '--transparent', to: '--newsletter-2-input-hover-color', name: 'Input Hover Color' },
			{ from: '--cta-color-pure', to: '--newsletter-2-cta-pure', name: 'CTA Color' },
			{ from: '--cta-color-focus', to: '--newsletter-2-cta-focus', name: 'CTA Focus Color' },
			{ from: '--cta-color-hover', to: '--newsletter-2-cta-hover', name: 'CTA Hover Color' },
			{ from: '--white', to: '--newsletter-2-cta-text-color', name: 'CTA Text Color' },
			{ from: '--white', to: '--newsletter-2-politicas-link', name: 'Políticas Link Color' },
		],
	},
	{
		type: 'borderRadius',
		list: [{ from: '--border-radius-none', to: '--newsletter-2-border-radius', name: 'Border Radius' }],
	},
	{
		type: 'fontSize',
		list: [
			{ from: '--font-size-xxl', to: '--newsletter-2-header-desktop-size', name: 'Header Desktop Size' },
			{ from: '--font-size-xl', to: '--newsletter-2-header-mobile-size', name: 'Header Mobile Size' },
			{ from: '--font-size-sm', to: '--newsletter-2-input-size', name: 'Input Font Size' },
			{ from: '--font-size-sm', to: '--newsletter-2-cta-size', name: 'CTA Font Size' },
			{ from: '--font-size-xs', to: '--newsletter-2-info-size', name: 'Infotext Font Size' },
		],
	},
	{
		type: 'typography',
		list: [
			{ from: '--main-font', to: '--newsletter-2-header-font', name: 'Headline Font Family' },
			{ from: '--main-font', to: '--newsletter-2-body-font', name: 'Body Font Family' },
			{ from: '--main-font', to: '--newsletter-2-cta-font', name: 'CTA Font Family' },
		],
	},
];
